<script>
	let hovered = false;
	export let selected = false;
</script>

<div
	on:mouseenter={() => (hovered = true)}
	on:mouseleave={() => (hovered = false)}
	class:hovered
	class:selected
>
	<slot />
</div>

<style>
	div {
		outline: 2px solid var(--background-4);
		background: var(--background-2);
		display: inline-block;
		margin: 1rem;
		padding: 1rem;
	}

	div.hovered {
		outline: 2px solid var(--button-secondary);
	}

	/* disable the hover view when on a touch device */
	@media (hover: none) {
		div.hovered {
			outline: 2px solid var(--background-4);
		}
	}

	div.selected {
		outline: 2px solid var(--link);
	}
</style>
